module.exports = __webpack_public_path__ + "img/blue.51d2a1cf.png";